<template>
  <div class="modern-app">
    <!-- Header Component -->
    <header-component />

    <!-- Notification Section -->
    <div v-if="notification.message" class="notification-box">
      <div :class="['notification', notification.type]">
        {{ notification.message }}
      </div>
    </div>

    <!-- Main Content -->
    <div class="container" dir="rtl">
      <div class="page-header">
        <h1>سفارة معرفة مكتبة الإسكندرية</h1>
        <h2>جامعة العلمين الدولية</h2>
      </div>

      <!-- Knowledge Embassy Information Sections -->
      <div class="sections-container">
        <!-- About Knowledge Embassies -->
        <section id="about" class="info-section" :class="{ 'expanded': openSection === 'about' }">
          <div class="section-title" @click="toggleSection('about')">
            <div class="section-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
            </div>
            <h3>نبذة عن سفارات المعرفة</h3>
            <span class="arrow-icon">{{ openSection === 'about' ? '▲' : '▼' }}</span>
          </div>
          <div v-if="openSection === 'about'" class="section-content">
            <p>
              تطورت مكتبة الإسكندرية منذ إنشائها لتحوي اليوم الكثير من الإمكانيات العلمية والبحثية والتكنولوجية، مما هيأ لها أن تتبوأ مكانة متقدمة في شتى المجالات العلمية والثقافية والمعرفية. وفي عام 2014 جاء التفكير في إنشاء سفارات لمكتبة الإسكندرية في جميع المحافظات، وبذلك تتمكن المكتبة من تخطي البعد الجغرافي، وتوصيل خدماتها إلى أكبر عدد ممكن من المستفيدين.
            </p>
            <p>
              وفي ظل الثورة التكنولوجية والمعلوماتية التي يشهدها العالم، أصبحت هذه المهمة ممكنة من خلال سفارات المعرفة التابعة لمكتبة الإسكندرية؛ وهي عبارة عن مكتبات أُنشئت في أماكن متفاوتة اجتماعيًّا ومتباعدة جغرافيًّا في جميع أنحاء مصر تحت إدارة مكتبة الإسكندرية بهدف ربطها بالمكتبة بشكل مباشر للاستفادة من إمكانياتها؛ ويحظى جمهور هذه المكتبات السفيرة بنفس الخدمات التي تقدمها مكتبة الإسكندرية لجمهورها داخل مقرها الرئيسي.
            </p>
          </div>
        </section>

        <!-- Goals of the Knowledge Embassy -->
        <section id="goals" class="info-section" :class="{ 'expanded': openSection === 'goals' }">
          <div class="section-title" @click="toggleSection('goals')">
            <div class="section-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 8h1a4 4 0 0 1 0 8h-1"></path>
                <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path>
                <line x1="6" y1="1" x2="6" y2="4"></line>
                <line x1="10" y1="1" x2="10" y2="4"></line>
                <line x1="14" y1="1" x2="14" y2="4"></line>
              </svg>
            </div>
            <h3>أهداف سفارة المعرفة</h3>
            <span class="arrow-icon">{{ openSection === 'goals' ? '▲' : '▼' }}</span>
          </div>
          <div v-if="openSection === 'goals'" class="section-content">
            <ul>
              <li>تمثيل مكتبة الإسكندرية في جميع محافظات مصر بصفتها مراكز فرعية.</li>
              <li>تطوير مهارات الطلاب في البحث العلمي.</li>
              <li>تشجيع الطلاب على التعلم الذاتي، وتنمية مهاراتهم في شتى المجالات العلمية والثقافية والمعرفية.</li>
              <li>إلقاء الضوء على أهم الأحداث والفاعليات المحلية والدولية، والمشاركة فيها بما يتناسب مع الجو الخاص بكل محافظة.</li>
              <li>الحفاظ على التراث الثقافي المصري بكافة ألوان الفنون، عن طريق تنظيم مجموعة من الأنشطة وورش العمل التفاعلية في مختلف المجالات العلمية والأدبية والفنية.</li>
            </ul>
          </div>
        </section>

        <!-- Services Provided by the Knowledge Embassy -->
        <section id="services" class="info-section" :class="{ 'expanded': openSection === 'services' }">
          <div class="section-title" @click="toggleSection('services')">
            <div class="section-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
          <line x1="8" y1="21" x2="16" y2="21"></line>
          <line x1="12" y1="17" x2="12" y2="21"></line>
        </svg>
            </div>
            <h3>الخدمات التي تقدمها سفارة المعرفة</h3>
            <span class="arrow-icon">{{ openSection === 'services' ? '▲' : '▼' }}</span>
          </div>
          <div v-if="openSection === 'services'" class="section-content">
            <ul>
              <li>تشمل قاعة سفارة المعرفة على مجموعة أجهزة حاسب آلي مرتبطة بنظام آلي مباشرة بمكتبة الإسكندرية.</li>
              <li>يستطيع الباحث الاطلاع على النصوص الكاملة لمحتوى مستودع الأصول الرقمية الخاص بالمكتبة.</li>
              <li>يستطيع الباحث استخدام قواعد البيانات العالمية التي تشترك بها مكتبة الإسكندرية مثل (Ebsco, ProQuest).</li>
              <li>تقدم المكتبة خدمة البث المباشر للفعاليات والندوات والمؤتمرات التي تقدم في مكتبة الإسكندرية.</li>
              <li>تعمل سفارة المعرفة دائماً على تنمية مهارات الطلاب من خلال تقديم العديد من ورش العمل والندوات.</li>
              <li>جميع الخدمات التي تقدم داخل سفارة المعرفة مجانية تماماً بدون مقابل.</li>
            </ul>
          </div>
        </section>

        <!-- Activities of the Knowledge Embassy -->
        <section id="activities" class="info-section" :class="{ 'expanded': openSection === 'activities' }">
          <div class="section-title" @click="toggleSection('activities')">
            <div class="section-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
              </svg>
            </div>
            <h3>أنشطة السفارة</h3>
            <span class="arrow-icon">{{ openSection === 'activities' ? '▲' : '▼' }}</span>
          </div>
          <div v-if="openSection === 'activities'" class="section-content">
            <ul>
              <li>الاحتفال بالمناسبات الدولية مثل (اليوم العالمي للشباب، اليوم العالمي للمرأة، اليوم العالمي للشعر).</li>
              <li>الاحتفال بالمناسبات المحلية مثل (العيد القومي لمحافظة مطروح).</li>
              <li>إقامة ورش عمل تنمية مهارات الطلاب مثل (تعليم الكروشيه، الرسم، الأكسسوارات).</li>
              <li>إقامة ورش العمل في تنمية مهارات استخدام الحاسب الآلي والإنترنت.</li>
              <li>إقامة الندوات العلمية مثل (التوعية من مخاطر مرض السرطان، الجديد في عالم المكتبات).</li>
            </ul>
          </div>
        </section>
      </div>

      <!-- Slot Registration Section -->
      <section id="registration" class="registration-section">
        <div class="section-header">
          <h2>حجز خدمات سفارة المعرفة</h2>
          <p>اختر اليوم والوقت المناسب للتسجيل:</p>
        </div>

        <!-- Loading Spinner -->
        <div v-if="loading" class="loading-container">
          <div class="spinner"></div>
          <p>جاري تحميل المواعيد...</p>
        </div>

          <!-- Month Navigation -->
          <div v-if="!loading" div class="month-navigation">
            <button @click="previousMonth" :disabled="!hasPreviousMonth" class="pagination-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
            
            <h4 class="current-month">{{ currentMonthName }} {{ currentYear }}</h4>
            
              <button @click="nextMonth" :disabled="!hasNextMonth" class="pagination-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>
          
          <button @click="goToCurrentMonth" class="today-button">
            الشهر الحالي
          </button>
        </div>

        <!-- Slot Grid -->
        <div v-if="!loading" class="slot-grid">
          <!-- See More/Hide Text for Past Dates -->
          <div v-if="hasPastDatesInMonth" class="see-more-container">
            <div class="see-more-text" :class="{ 'hide-mode': showOldDates }" @click="toggleOldDates">
              <svg v-if="!showOldDates" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="18 15 12 9 6 15"></polyline>
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
              <span>{{ showOldDates ? 'إخفاء المواعيد السابقة للشهر الحالي' : 'عرض المواعيد السابقة للشهر الحالي' }}</span>
              <svg v-if="!showOldDates" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="18 15 12 9 6 15"></polyline>
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>
          </div>
          
          <!-- Loop through grouped slots by date -->
          <div v-for="(slots, date) in groupedSlotsByDate" :key="date" class="day-row" :class="{ 'expanded': expandedDay === date }">
            <div class="day-header" @click="toggleDay(date)">
              <div class="day-info">
                <span class="day-name">{{ getDayName(date) }}</span>
                <span class="day-date">{{ formatDate(date) }}</span>
              </div>
              <span class="arrow-icon">{{ expandedDay === date ? '▲' : '▼' }}</span>
            </div>
            <div v-if="expandedDay === date" class="time-slots">
              <div v-for="slot in slots" :key="slot._id" class="time-slot" :class="{ 'passed': isSlotPassed(slot) }">
                <div class="slot-time">
                  <span class="time-label">من</span>
                  <span class="time-value">{{ formatTimeTo12H(slot.start_time) }}</span>
                  <span class="time-label">إلى</span>
                  <span class="time-value">{{ formatTimeTo12H(slot.end_time) }}</span>
                </div>
                <div class="slot-duration">
                  <span class="duration-value">{{ calculateDuration(slot.start_time, slot.end_time) }}</span>
                </div>
                <div class="slot-location">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                  مبني 8 الدور الثاني قاعة 3097
                </div>
                <div class="slot-devices">
                  <span>الأجهزة المتاحة: {{ slot.max_devices - slot.current_devices }} / {{ slot.max_devices }}</span>
                </div>

                <!-- Show "التسجيل" button if available and not passed, else show appropriate message -->
                <button
                  v-if="slot.is_available && !isSlotPassed(slot)"
                  @click="showRegistrationForm(slot)"
                  :disabled="loading"
                  class="register-button"
                >
                  <span v-if="loading" class="button-spinner"></span>
                  <span v-else>التسجيل</span>
                </button>
                <div v-else-if="!slot.is_available" class="slot-status unavailable">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
                  </svg>
                  الموعد محجوز بالكامل
                </div>
                <div v-else class="slot-status expired">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
                  انتهت صلاحية الموعد
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Registration Form Modal -->
      <div v-if="showForm" class="registration-modal">
        <div class="modal-overlay" @click="closeRegistrationForm"></div>
        <div class="modal-container">
          <div class="modal-header">
            <h3>التسجيل في الموعد</h3>
            <button @click="closeRegistrationForm" class="close-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <div class="slot-details">
              <div class="detail-row">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                <span>{{ getDayName(selectedSlot.date) }} ({{ formatDate(selectedSlot.date) }})</span>
              </div>
              <div class="detail-row">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
                <span>{{ formatTimeTo12H(selectedSlot.start_time) }} - {{ formatTimeTo12H(selectedSlot.end_time) }}</span>
              </div>
              <div class="detail-row">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
                <span>{{ calculateDuration(selectedSlot.start_time, selectedSlot.end_time) }}</span>
              </div>
              <div class="detail-row">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <span>مبني 8 الدور الثاني قاعة 3097</span>
              </div>
              <div class="detail-row">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                  <line x1="8" y1="21" x2="16" y2="21"></line>
                  <line x1="12" y1="17" x2="12" y2="21"></line>
                </svg>
                <span>الأجهزة المتاحة: {{ selectedSlot.max_devices - selectedSlot.current_devices }} / {{ selectedSlot.max_devices }}</span>
              </div>
            </div>

            <!-- Computer Selection Section -->
            <div class="computer-selection">
              <h4>اختر جهاز الكمبيوتر</h4>
              <div v-if="availableDevices.length > 0" class="computer-grid">
                <!-- First Column (Devices 5, 4, 3, 2, 1) -->
                <div class="computer-column">
                  <div
                    v-for="device in [5, 4, 3, 2, 1]"
                    :key="device"
                    :class="['computer', 
                             { 'selected': selectedComputer === device },
                             { 'unavailable': !availableDevices.includes(device) }]"
                    @click="availableDevices.includes(device) ? selectComputer(device) : null"
                  >
                    <div class="computer-screen">{{ device }}</div>
                    <div class="computer-base"></div>
                    <div v-if="!availableDevices.includes(device)" class="computer-taken">✗</div>
                  </div>
                </div>

                <!-- Second Column (Devices 6, 7, 8, 9, 10) -->
                <div class="computer-column">
                  <div
                    v-for="device in [6, 7, 8, 9, 10]"
                    :key="device"
                    :class="['computer', 
                             { 'selected': selectedComputer === device },
                             { 'unavailable': !availableDevices.includes(device) }]"
                    @click="availableDevices.includes(device) ? selectComputer(device) : null"
                  >
                    <div class="computer-screen">{{ device }}</div>
                    <div class="computer-base"></div>
                    <div v-if="!availableDevices.includes(device)" class="computer-taken">✗</div>
                  </div>
                </div>

                <!-- Space in the middle -->
                <div class="computer-space"></div>

                <!-- Third Column (Devices 15, 14, 13, 12, 11) -->
                <div class="computer-column">
                  <div
                    v-for="device in [15, 14, 13, 12, 11]"
                    :key="device"
                    :class="['computer', 
                             { 'selected': selectedComputer === device },
                             { 'unavailable': !availableDevices.includes(device) }]"
                    @click="availableDevices.includes(device) ? selectComputer(device) : null"
                  >
                    <div class="computer-screen">{{ device }}</div>
                    <div class="computer-base"></div>
                    <div v-if="!availableDevices.includes(device)" class="computer-taken">✗</div>
                  </div>
                </div>

                <!-- Fourth Column (Devices 16, 17, 18, 19, 20) -->
                <div class="computer-column">
                  <div
                    v-for="device in [16, 17, 18, 19, 20]"
                    :key="device"
                    :class="['computer', 
                             { 'selected': selectedComputer === device },
                             { 'unavailable': !availableDevices.includes(device) }]"
                    @click="availableDevices.includes(device) ? selectComputer(device) : null"
                  >
                    <div class="computer-screen">{{ device }}</div>
                    <div class="computer-base"></div>
                    <div v-if="!availableDevices.includes(device)" class="computer-taken">✗</div>
                  </div>
                </div>
              </div>
              <div v-else class="no-devices-available">
                جميع الأجهزة محجوزة في هذا الموعد
              </div>
            </div>

            <!-- Student ID Input -->
            <div class="form-group">
              <label for="student_id">الرقم الجامعي</label>
              <div class="input-container">
                <input
                  v-model="studentId"
                  @input="validateStudentId"
                  type="text"
                  id="student_id"
                  class="form-input"
                  placeholder="أدخل الرقم الجامعي"
                  required
                >
                <span v-if="studentIdValid === true" class="input-icon valid">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                </span>
                <span v-else-if="studentIdValid === false" class="input-icon invalid">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                  </svg>
                </span>
              </div>
              <div v-if="studentIdValid === false" class="error-message">
                ⚠️ الرقم الجامعي غير صحيح، يرجى التحقق منه
              </div>
              <div v-else-if="studentIdValid === true" class="success-message">
                الرقم الجامعي صحيح ✅
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="registerForSlot(selectedSlot)" :disabled="!studentIdValid || !selectedComputer || loading" class="confirm-button">
              <span v-if="loading" class="button-spinner"></span>
              <span v-else>تأكيد التسجيل</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Confirmation Modal -->
      <div v-if="showConfirmation" class="confirmation-modal">
        <div class="modal-overlay" @click="closeConfirmation"></div>
        <div class="modal-container">
          <div class="modal-header">
            <h3>تم التسجيل بنجاح</h3>
            <button @click="closeConfirmation" class="close-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <div class="modal-body" id="confirmation-content">
            <div class="confirmation-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#28a745" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            </div>
            <h4 class="confirmation-title">تم تأكيد حجزك بنجاح</h4>
            
            <div class="confirmation-details">
              <div class="detail-row">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                <span>{{ getDayName(confirmedRegistration.date) }} ({{ formatDate(confirmedRegistration.date) }})</span>
              </div>
              <div class="detail-row">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
                <span>{{ formatTimeTo12H(confirmedRegistration.start_time) }} - {{ formatTimeTo12H(confirmedRegistration.end_time) }}</span>
              </div>
              <div class="detail-row">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
                <span>{{ calculateDuration(confirmedRegistration.start_time, confirmedRegistration.end_time) }}</span>
              </div>
              <div class="detail-row">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <span>مبني 8 الدور الثاني قاعة 3097</span>
              </div>
              <div class="detail-row">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                  <line x1="8" y1="21" x2="16" y2="21"></line>
                  <line x1="12" y1="17" x2="12" y2="21"></line>
                </svg>
                <span>رقم جهاز الكمبيوتر: {{ confirmedRegistration.computer }}</span>
              </div>
              <div class="detail-row">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="8.5" cy="7" r="4"></circle>
                  <line x1="20" y1="8" x2="20" y2="14"></line>
                  <line x1="23" y1="11" x2="17" y2="11"></line>
                </svg>
                <span>الرقم الجامعي: {{ confirmedRegistration.student_id }}</span>
              </div>
            </div>
            
            <div class="confirmation-actions">
              <button @click="printConfirmation" class="print-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="6 9 6 2 18 2 18 9"></polyline>
                  <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                  <rect x="6" y="14" width="12" height="8"></rect>
                </svg>
                حفظ
              </button>
              <button @click="closeConfirmation" class="close-confirmation-button">
                إغلاق
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Component -->
    <footer-component />
  </div>
</template>

<script>
import axios from 'axios';
import HeaderComponent from '../../../public/global/headerComponent.vue';
import FooterComponent from '../../../public/global/footerComponent.vue';

export default {
  name: 'Home',
  components: { HeaderComponent, FooterComponent },
  data() {
    return {
      openSection: null,
      expandedDay: null,
      slots: [],
      loading: true,
      showForm: false,
      selectedSlot: null,
      studentId: '',
      studentIdValid: null,
      studentsMap: {},
      notification: {
        message: '',
        type: '',
      },
      currentMonth: new Date().getMonth(),
      currentYear: new Date().getFullYear(),
      selectedComputer: null,
      availableDevices: [],
      showConfirmation: false,
      confirmedRegistration: {
        date: '',
        start_time: '',
        end_time: '',
        computer: null,
        student_id: ''
      },
      confirmationNumber: '',
      showOldDates: false
    };
  },
  computed: {
    filteredSlots() {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set to beginning of today for date comparison
      
      return this.slots.filter(slot => {
        const slotDate = new Date(slot.date);
        const isCurrentMonth = (
          slotDate.getMonth() === this.currentMonth &&
          slotDate.getFullYear() === this.currentYear
        );
        
        // Check if we're viewing the actual current month
        const isViewingCurrentMonth = (
          this.currentMonth === today.getMonth() &&
          this.currentYear === today.getFullYear()
        );
        
        // For past months, always show all slots without filtering
        if (!isViewingCurrentMonth) {
          return isCurrentMonth;
        }
        
        // For current month: apply show/hide logic for past dates
        if (this.showOldDates) {
          return isCurrentMonth;
        }
        
        // Otherwise, only show slots from today onwards in current month
        return isCurrentMonth && slotDate >= today;
      });
    },
    groupedSlotsByDate() {
      const grouped = {};
      this.filteredSlots.forEach(slot => {
        const date = slot.date;
        if (!grouped[date]) {
          grouped[date] = [];
        }
        grouped[date].push(slot);
      });

      const sortedDates = Object.keys(grouped).sort((a, b) => new Date(a) - new Date(b));

      const sortedGrouped = {};
      sortedDates.forEach(date => {
        sortedGrouped[date] = grouped[date].sort((a, b) => {
          return new Date(`1970-01-01T${a.start_time}`) - new Date(`1970-01-01T${b.start_time}`);
        });
      });

      return sortedGrouped;
    },
    hasPastDatesInMonth() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      // Only show the toggle if we're viewing the actual current month
      const isViewingCurrentMonth = (
        this.currentMonth === today.getMonth() &&
        this.currentYear === today.getFullYear()
      );
      
      if (!isViewingCurrentMonth) {
        return false;
      }
      
      return this.slots.some(slot => {
        const slotDate = new Date(slot.date);
        return (
          slotDate.getMonth() === this.currentMonth &&
          slotDate.getFullYear() === this.currentYear &&
          slotDate < today
        );
      });
    },
    currentMonthName() {
      const months = [
        'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
        'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
      ];
      return months[this.currentMonth];
    },
    hasPreviousMonth() {
      const previousMonth = this.currentMonth === 0 ? 11 : this.currentMonth - 1;
      const previousYear = this.currentMonth === 0 ? this.currentYear - 1 : this.currentYear;
      return this.slots.some(slot => {
        const slotDate = new Date(slot.date);
        return (
          slotDate.getMonth() === previousMonth &&
          slotDate.getFullYear() === previousYear
        );
      });
    },
    hasNextMonth() {
      const nextMonth = this.currentMonth === 11 ? 0 : this.currentMonth + 1;
      const nextYear = this.currentMonth === 11 ? this.currentYear + 1 : this.currentYear;
      return this.slots.some(slot => {
        const slotDate = new Date(slot.date);
        return (
          slotDate.getMonth() === nextMonth &&
          slotDate.getFullYear() === nextYear
        );
      });
    },
  },
  async mounted() {
    this.openSectionFromHash();
    window.addEventListener('hashchange', this.openSectionFromHash);
    await this.loadStudentData();
    await this.loadSlots();
    this.loading = false;
  },
  beforeUnmount() {
    window.removeEventListener('hashchange', this.openSectionFromHash);
  },
  methods: {
    openSectionFromHash() {
      const hash = window.location.hash.substring(1);
      if (['about', 'goals', 'services', 'activities'].includes(hash)) {
        this.openSection = hash;
      } else {
        this.openSection = null;
      }
    },
    toggleSection(section) {
      if (this.openSection === section) {
        this.openSection = null;
        window.location.hash = '';
      } else {
        this.openSection = section;
        window.location.hash = section;
      }
    },
    showNotification(message, type = 'success') {
      this.notification.message = message;
      this.notification.type = type;
      setTimeout(() => {
        this.notification.message = '';
      }, 3000);
    },
    async loadStudentData() {
      try {
        const response = await axios.get('https://aiusu-backend.vercel.app/sdata');
        this.studentsMap = response.data.reduce((map, student) => {
          map[student.student_id] = student;
          return map;
        }, {});
      } catch (error) {
        console.error('Error loading student data:', error);
        this.showNotification('فشل تحميل بيانات الطلاب', 'error');
      }
    },
    async loadSlots() {
      try {
        const response = await axios.get('https://eok-aiu-backend.vercel.app/slots/list');
        this.slots = this.sortSlots(response.data);
      } catch (error) {
        console.error('Error loading slots:', error);
        this.showNotification('فشل تحميل المواعيد', 'error');
      }
    },
    sortSlots(slots) {
      return slots.sort((a, b) => {
        const dateA = new Date(`${a.date}T${a.start_time}`);
        const dateB = new Date(`${b.date}T${b.start_time}`);
        
        if (dateA.toDateString() !== dateB.toDateString()) {
          return dateA - dateB;
        }
        
        return new Date(`1970-01-01T${a.start_time}`) - new Date(`1970-01-01T${b.start_time}`);
      });
    },
    formatDate(date) {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },
    getDayName(date) {
      const days = ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];
      const dayIndex = new Date(date).getDay();
      return days[dayIndex];
    },
    formatTimeTo12H(time) {
      if (!time) return '';

      const [hours, minutes] = time.split(':');
      let period = 'ص';
      let formattedHours = parseInt(hours, 10);

      if (formattedHours >= 12) {
        period = 'م';
        if (formattedHours > 12) {
          formattedHours -= 12;
        }
      } else if (formattedHours === 0) {
        formattedHours = 12;
      }

      return `${formattedHours}:${minutes} ${period}`;
    },
    calculateDuration(startTime, endTime) {
      if (!startTime || !endTime) {
        return 'غير متاح';
      }

      const start = new Date(`1970-01-01T${startTime}:00`);
      const end = new Date(`1970-01-01T${endTime}:00`);

      if (isNaN(start) || isNaN(end)) {
        return 'غير متاح';
      }

      if (end <= start) return 'غير متاح';

      const diff = end - start;
      const hours = Math.floor(diff / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      return `${hours} ساعة ${minutes} دقيقة`;
    },
    isSlotPassed(slot) {
      const now = new Date();
      const slotDate = new Date(slot.date);
      const slotStartTime = new Date(`${slot.date}T${slot.start_time}:00`);

      if (slotDate.toDateString() === now.toDateString()) {
        return now >= slotStartTime;
      }

      return slotDate < now;
    },
    validateStudentId() {
      if (!this.studentId) {
        this.studentIdValid = null;
        return;
      }
      this.studentIdValid = this.studentsMap[this.studentId] ? true : false;
    },
    async showRegistrationForm(slot) {
      this.selectedSlot = slot;
      this.selectedComputer = null;
      
      try {
        // Fetch available devices for this slot
        const response = await axios.get(`https://eok-aiu-backend.vercel.app/registrations/${slot._id}/devices`);
        this.availableDevices = response.data.availableDevices || [];
        
        if (this.availableDevices.length === 0) {
          this.showNotification('جميع الأجهزة محجوزة في هذا الموعد', 'error');
          return;
        }
        
        this.showForm = true;
      } catch (error) {
        console.error('Error fetching available devices:', error);
        this.showNotification('فشل تحميل بيانات الأجهزة', 'error');
      }
    },
    closeRegistrationForm() {
      this.showForm = false;
      this.studentId = '';
      this.studentIdValid = null;
      this.selectedComputer = null;
      this.availableDevices = [];
    },
    async registerForSlot(slot) {
      if (!this.studentIdValid) {
        this.showNotification('الرجاء إدخال رقم جامعي صحيح قبل التسجيل', 'error');
        return;
      }

      if (!this.selectedComputer) {
        this.showNotification('الرجاء اختيار جهاز الكمبيوتر قبل التسجيل', 'error');
        return;
      }

      this.loading = true;

      try {
        const response = await axios.post('https://eok-aiu-backend.vercel.app/registrations/register', {
          slot_id: slot._id,
          student_id: this.studentId,
          computer: this.selectedComputer
        });

        if (response.data.message === 'Registration successful') {
          this.showRegistrationConfirmation(slot);
          await this.loadSlots();
          this.showNotification('!تم التسجيل بنجاح', 'success');
        } else {
          this.showNotification('فشل التسجيل. يرجى المحاولة مرة أخرى.', 'error');
        }
      } catch (error) {
        console.error('Error registering for slot:', error);

        if (error.response) {
          const errorMessage = error.response.data.error || error.response.statusText;
          if (errorMessage.includes('Device already taken')) {
            this.showNotification('هذا جهاز الكمبيوتر محجوز بالفعل، يرجى اختيار جهاز آخر', 'error');
          } else if (errorMessage.includes('Slot is not available')) {
            this.showNotification('الموعد غير متاح. يرجى اختيار موعد آخر', 'error');
          } else {
            this.showNotification(`حدث خطأ أثناء التسجيل: ${errorMessage}`, 'error');
          }
        } else if (error.request) {
          this.showNotification('لا يوجد اتصال بالخادم. يرجى التحقق من اتصال الشبكة', 'error');
        } else {
          this.showNotification('حدث خطأ غير متوقع أثناء التسجيل.', 'error');
        }
      } finally {
        this.loading = false;
        this.closeRegistrationForm();
      }
    },
    toggleDay(date) {
      if (this.expandedDay === date) {
        this.expandedDay = null;
      } else {
        this.expandedDay = date;
      }
    },
    previousMonth() {
      if (this.currentMonth === 0) {
        this.currentMonth = 11;
        this.currentYear--;
      } else {
        this.currentMonth--;
      }
    },
    nextMonth() {
      if (this.currentMonth === 11) {
        this.currentMonth = 0;
        this.currentYear++;
      } else {
        this.currentMonth++;
      }
    },
    goToCurrentMonth() {
      this.currentMonth = new Date().getMonth();
      this.currentYear = new Date().getFullYear();
    },
    toggleOldDates() {
      this.showOldDates = !this.showOldDates;
    },
    selectComputer(computerNumber) {
      this.selectedComputer = computerNumber;
    },
    generateConfirmationNumber() {
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
      let result = '';
      for (let i = 0; i < 8; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result;
    },
    showRegistrationConfirmation(slot) {
      this.confirmedRegistration = {
        date: slot.date,
        start_time: slot.start_time,
        end_time: slot.end_time,
        computer: this.selectedComputer,
        student_id: this.studentId
      };
      this.confirmationNumber = this.generateConfirmationNumber();
      this.showConfirmation = true;
    },
    closeConfirmation() {
      this.showConfirmation = false;
      this.studentId = '';
      this.selectedComputer = null;
    },
    printConfirmation() {
      const printContents = document.getElementById('confirmation-content').innerHTML;
      const originalContents = document.body.innerHTML;
      
      document.body.innerHTML = `
        <div style="direction: rtl; text-align: right; padding: 20px; font-family: Arial, sans-serif;">
          <h2 style="text-align: center; color: #0f106c;">سفارة معرفة مكتبة الإسكندرية</h2>
          <h3 style="text-align: center;">جامعة العلمين الدولية</h3>
          <div style="margin-top: 30px;">${printContents}</div>
          <div style="margin-top: 30px; text-align: center; font-size: 12px; color: #666;">
            تم الحفظ في ${new Date().toLocaleString('ar-EG')}
          </div>
        </div>
      `;
      
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload();
    },
  },
};
</script>

<style scoped>
/* Modern App Base Styles */
.modern-app {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #f8f9fa;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
  flex: 1;
}

/* Page Header */
.page-header {
  text-align: center;
  margin-bottom: 3rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #eee;
}

.page-header h1 {
  font-size: 2.5rem;
  color: #0f106c;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.page-header h2 {
  font-size: 1.8rem;
  color: #555;
  font-weight: 500;
}

/* Sections Container */
.sections-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 3rem;
}

/* Info Sections */
.info-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s ease;
}

.info-section.expanded {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.section-title {
  display: flex;
  align-items: center;
  padding: 1.25rem 1.5rem;
  cursor: pointer;
  background-color: #f8f9fa;
  transition: background-color 0.3s ease;
}

.section-title:hover {
  background-color: #f1f3f5;
}

.section-icon {
  margin-left: 1rem;
  color: #0f106c;
  display: flex;
  align-items: center;
}

.section-title h3 {
  margin: 0;
  font-size: 1.25rem;
  color: #0f106c;
  flex: 1;
  font-weight: 600;
}

.arrow-icon {
  color: #0f106c;
  font-size: 1rem;
  transition: transform 0.3s ease;
}

.section-content {
  padding: 1.5rem;
}

.section-content p {
  text-align: right;
  margin-bottom: 1rem;
  color: #555;
  line-height: 1.8;
}

.section-content ul {
  list-style-type: none;
  padding-right: 0;
  margin: 0;
}

.section-content li {
  position: relative;
  padding-right: 1.5rem;
  margin-bottom: 0.75rem;
  color: #555;
  line-height: 1.6;
}

.section-content li:before {
  content: "•";
  position: absolute;
  right: 0;
  color: #0f106c;
  font-weight: bold;
}

/* Registration Section */
.registration-section {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-top: 2rem;
}

.section-header {
  text-align: center;
  margin-bottom: 2rem;
}

.section-header h2 {
  font-size: 1.8rem;
  color: #0f106c;
  margin-bottom: 0.5rem;
}

.section-header p {
  color: #666;
  margin-bottom: 0;
}

/* Loading Spinner */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.spinner {
  width: 3rem;
  height: 3rem;
  border: 4px solid rgba(15, 16, 108, 0.1);
  border-radius: 50%;
  border-top-color: #0f106c;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Month Navigation */
.month-navigation {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.current-month {
  margin: 0 -0.5rem;
  font-size: 1.3rem;
  color: #0f106c;
  font-weight: 600;
  min-width: 180px;
  text-align: center;
}

.nav-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #0f106c;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.nav-button:hover:not(:disabled) {
  background-color: #c92126;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.nav-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.7;
}

.today-button {
  padding: 0.5rem 1rem;
  background-color: #0f106c;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.today-button:hover {
  background-color: #c92126 ;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Slot Grid */
.slot-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* See More Container */
.see-more-container {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.see-more-text {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background-color: #f8f9fa;
  border: 2px dashed #c92126;
  border-radius: 8px;
  color: #c92126;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 0.95rem;
}

.see-more-text:hover {
  background-color: rgba(201, 33, 38, 0.1);
  color: #c92126;
  border-color: #c92126;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(201, 33, 38, 0.2);
}

.see-more-text.hide-mode {
  background-color: #e8f4f8;
  border-color: #0f106c;
  color: #0f106c;
}

.see-more-text.hide-mode:hover {
  background-color: rgba(15, 16, 108, 0.1);
  color: #0f106c;
  border-color: #0f106c;
  box-shadow: 0 4px 8px rgba(15, 16, 108, 0.2);
}

.see-more-text svg {
  transition: transform 0.3s ease;
}

.see-more-text:hover svg {
  transform: translateY(-2px);
}

.day-row {
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.3s ease;
}

.day-row.expanded {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.day-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background-color: #f8f9fa;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.day-header:hover {
  background-color: #f1f3f5;
}

.day-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.day-name {
  font-weight: 600;
  color: #0f106c;
  font-size: 1.1rem;
}

.day-date {
  background-color: #0f106c;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.85rem;
}

.time-slots {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
  padding: 1.5rem;
  border-top: 1px solid #eee;
}

.time-slot {
  background: white;
  border-radius: 8px;
  padding: 1.25rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  border: 1px solid #eee;
}

.time-slot:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.time-slot.passed {
  opacity: 0.7;
  background-color: #f8f9fa;
}

.slot-time {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  justify-content: center;
}

.time-label {
  font-size: 0.9rem;
  color: #666;
}

.time-value {
  font-weight: 600;
  color: #0f106c;
  font-size: 1.1rem;
}

.slot-duration {
  text-align: center;
  margin-bottom: 0.75rem;
}

.duration-value {
  font-size: 0.9rem;
  color: #666;
  background-color: #f1f3f5;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
}

.slot-location {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.75rem;
}

.slot-location svg {
  color: #0f106c;
}

.slot-devices {
  text-align: center;
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 1rem;
}

.register-button {
  width: 100%;
  padding: 0.75rem;
  background-color: #c92126;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 1rem;
}

.register-button:hover:not(:disabled) {
  background-color: #0f106c;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.register-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.slot-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
}

.slot-status.unavailable {
  background-color: #fff5f5;
  color: #dc3545;
}

.slot-status.expired {
  background-color: #f8f9fa;
  color: #c92126;
}

/* Registration Modal */
.registration-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-container {
  position: relative;
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  animation: modalFadeIn 0.3s ease;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.5rem;
  color: #0f106c;
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  transition: color 0.3s ease;
  padding: 0.5rem;
}

.close-button:hover {
  color: #c92126;
}

.modal-body {
  padding: 1.5rem;
}

.slot-details {
  margin-bottom: 2rem;
}

.detail-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding: 0.75rem;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.detail-row svg {
  color: #0f106c;
}

/* Computer Selection */
.computer-selection {
  margin-bottom: 2rem;
}

.computer-selection h4 {
  font-size: 1.25rem;
  color: #0f106c;
  margin-bottom: 1.5rem;
  text-align: center;
}

.computer-grid {
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.computer-column {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.computer-space {
  width: 2rem;
  flex-shrink: 0;
}

.computer {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.computer:hover:not(.unavailable):not(.selected) {
  transform: translateY(-5px);
}

.computer.selected .computer-screen {
  background-color: #0f106c;
  color: white;
}

.computer.unavailable {
  opacity: 0.5;
  cursor: not-allowed;
}

.computer.unavailable .computer-screen {
  background-color: #f8d7da;
  border-color: #f5c6cb;
}

.computer-screen {
  width: 60px;
  height: 40px;
  background-color: #f1f3f5;
  border: 2px solid #ddd;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}

.computer-base {
  width: 70px;
  height: 8px;
  background-color: #ddd;
  border-radius: 0 0 4px 4px;
  margin-top: 4px;
}

.computer-taken {
  position: absolute;
  color: #dc3545;
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: -10px;
}

.no-devices-available {
  text-align: center;
  padding: 1rem;
  background-color: #f8d7da;
  color: #721c24;
  border-radius: 8px;
  margin-top: 1rem;
}

/* Form Group */
.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #333;
}

.input-container {
  position: relative;
}

.form-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
  padding-right: 2.5rem;
}

.form-input:focus {
  outline: none;
  border-color: #0f106c;
  box-shadow: 0 0 0 3px rgba(15, 16, 108, 0.1);
}

.input-icon {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
}

.input-icon.valid {
  color: #28a745;
}

.input-icon.invalid {
  color: #dc3545;
}

.error-message {
  color: #dc3545;
  font-size: 0.85rem;
  margin-top: 0.5rem;
}

.success-message {
  color: #28a745;
  font-size: 0.85rem;
  margin-top: 0.5rem;
}

/* Modal Footer */
.modal-footer {
  padding: 1.5rem;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: center;
}

.confirm-button {
  padding: 0.75rem 2rem;
  background-color: #c92126;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 1rem;
}

.confirm-button:hover:not(:disabled) {
  background-color: #0f106c;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.confirm-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

/* Button Spinner */
.button-spinner {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s linear infinite;
}

/* Notification Box */
.notification-box {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1100;
}

.notification {
  padding: 1rem 1.5rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: fadeIn 0.5s, fadeOut 0.5s 2.5s forwards;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.notification.success {
  background-color: #28a745;
}

.notification.error {
  background-color: #dc3545;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(100%);
  }
}

/* Confirmation Modal Styles - Consistent Across All Devices */
.confirmation-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.confirmation-modal .modal-container {
  position: relative;
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  padding: 2rem;
}

.confirmation-icon {
  text-align: center;
  margin: 1rem 0 2rem;
}

.confirmation-icon svg {
  width: 60px;
  height: 60px;
}

.confirmation-title {
  text-align: center;
  color: #28a745;
  margin-bottom: 2rem;
  font-size: 1.5rem;
  font-weight: 600;
}

.confirmation-details {
  background-color: #f8f9fa;
  border-radius: 10px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.confirmation-details .detail-row {
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  background-color: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.confirmation-details .detail-row:last-child {
  margin-bottom: 0;
}

.confirmation-details .detail-row svg {
  color: #0f106c;
  flex-shrink: 0;
}

.confirmation-number {
  text-align: center;
  margin-bottom: 2rem;
  padding: 1rem;
  background-color: #f1f3f5;
  border-radius: 8px;
  font-size: 1.1rem;
}

.confirmation-number p {
  margin: 0;
}

.confirmation-number strong {
  color: #0f106c;
  font-size: 1.2rem;
}

.confirmation-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.5rem;
}

.print-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background-color: #c92126;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 1rem;
  min-width: 160px;
}

.print-button:hover {
  background-color: #0f106c;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.print-button svg {
  width: 18px;
  height: 18px;
}

.close-confirmation-button {
  padding: 0.75rem 1.5rem;
  background-color: #f1f3f5;
  color: #333;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 1rem;
  min-width: 120px;
}

.close-confirmation-button:hover {
  background-color: #ddd;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .container {
    padding: 1rem;
  }

  .page-header {
    margin-bottom: 1.5rem;
    padding-bottom: 1rem;
  }

  .page-header h1 {
    font-size: 1.8rem;
    line-height: 1.3;
  }

  .page-header h2 {
    font-size: 1.3rem;
  }

  .info-section {
    border-radius: 10px;
  }

  .section-title {
    padding: 1rem;
  }

  .section-title h3 {
    font-size: 1.1rem;
  }

  .section-content {
    padding: 1rem;
    font-size: 0.95rem;
  }

  .section-content li {
    margin-bottom: 0.5rem;
    padding-right: 1rem;
  }

  .registration-section {
    padding: 1rem;
    margin-top: 1rem;
  }

  .section-header h2 {
    font-size: 1.5rem;
  }

  .month-navigation {
    gap: 0.5rem;
    margin-bottom: 1rem;
  }

  .current-month {
    font-size: 1.2rem;
    min-width: 150px;
  }

  .nav-button {
    width: 36px;
    height: 36px;
  }

  .today-button {
    padding: 0.4rem 0.8rem;
    font-size: 0.9rem;
  }

  .see-more-text {
    padding: 0.6rem 1.2rem;
    font-size: 0.9rem;
  }

  .day-header {
    padding: 0.75rem 1rem;
  }

  .day-name {
    font-size: 1rem;
  }

  .day-date {
    font-size: 0.8rem;
    padding: 0.2rem 0.6rem;
  }

  .time-slots {
    grid-template-columns: 1fr;
    padding: 1rem;
    gap: 0.75rem;
  }

  .time-slot {
    padding: 1rem;
  }

  .slot-time {
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.3rem;
  }

  .time-value {
    font-size: 1rem;
  }

  .slot-location {
    font-size: 0.85rem;
    flex-wrap: wrap;
    text-align: center;
  }

  .modal-container {
    width: 95%;
    max-height: 90vh;
  }

  .modal-header {
    padding: 1rem;
  }

  .modal-header h3 {
    font-size: 1.3rem;
  }

  .modal-body {
    padding: 1rem;
  }

  .detail-row {
    padding: 0.6rem;
    font-size: 0.95rem;
  }

  .form-group label {
    font-size: 0.95rem;
  }

  .form-input {
    padding: 0.65rem 0.9rem;
    font-size: 0.95rem;
  }

  .confirm-button {
    width: 100%;
    padding: 0.75rem;
  }
}

/* Extra small devices (phones, 480px and down) */
@media (max-width: 480px) {
  .page-header h1 {
    font-size: 1.6rem;
  }

  .page-header h2 {
    font-size: 1.1rem;
  }

  .section-title h3 {
    font-size: 1rem;
  }

  .section-content {
    font-size: 0.9rem;
  }

  .day-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.3rem;
  }

  .day-date {
    align-self: flex-start;
  }

  .time-slot {
    padding: 0.8rem;
  }

  /* Computer Selection - Only scale down slightly */
  .computer-screen {
    width: 35px;
    height: 20px;
    font-size: 1rem;
  }

  .computer-base {
    width: 30px;
  }
}

/* Very small devices (phones, 360px and down) */
@media (max-width: 360px) {
  .page-header h1 {
    font-size: 1.4rem;
  }

  .section-title {
    padding: 0.8rem;
  }

  .section-title h3 {
    font-size: 0.95rem;
  }

  .time-value {
    font-size: 0.95rem;
  }
  
  .modal-header h3 {
    font-size: 1.1rem;
  }
  
  .detail-row {
    font-size: 0.85rem;
  }
  
  .form-input {
    font-size: 0.9rem;
  }
}

/* Touch device optimizations */
@media (hover: none) {
  .section-title:hover {
    background-color: #f8f9fa;
  }
  
  .day-header:hover {
    background-color: #f8f9fa;
  }
  
  .time-slot:hover {
    transform: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  }
  
  .register-button:hover:not(:disabled) {
    transform: none;
    box-shadow: none;
  }
  
  .confirm-button:hover:not(:disabled) {
    transform: none;
    box-shadow: none;
  }
  
  .computer:hover:not(.unavailable):not(.selected) {
    transform: none;
  }
  
  .see-more-text:hover {
    transform: none;
    box-shadow: none;
  }
  
  .see-more-text.hide-mode:hover {
    transform: none;
    box-shadow: none;
  }
}

/* Print styles */
@media print {
  .modern-app {
    background: white;
  }
  
  .container {
    padding: 0;
  }
  
  .info-section {
    box-shadow: none;
    border: 1px solid #ddd;
    page-break-inside: avoid;
  }
  
  .registration-section {
    box-shadow: none;
    border: 1px solid #ddd;
    page-break-inside: avoid;
  }
  
  .section-title {
    background: #f1f1f1;
  }
  
  .day-header {
    background: #f1f1f1;
  }
  
  .notification-box,
  .registration-modal,
  .confirmation-modal .modal-overlay,
  .confirmation-modal .close-button,
  .confirmation-actions {
    display: none;
  }
  
  .confirmation-modal .modal-container {
    box-shadow: none;
    width: 100%;
    max-width: 100%;
  }
}
.pagination-buttons {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  justify-content: center;
}

.pagination-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  background-color: #c92126;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.95rem;
  font-weight: 500;
}

.pagination-button:hover:not(:disabled) {
  background-color: #0f106c;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.pagination-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.7;
}
</style>